import React from 'react'

const Homepage = () => {
    return (
        <div className='home-page-logo'>
            <p>Home SeeK</p>
        </div>
    )
}

export default Homepage
